import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Layout from "../../components/Layout.js";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const FinanceexecutiveMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const [ExecutiveName, setExecutiveName] = useState("");
  const [BankName, setBankName] = useState("");
  const [BankNamelist, setBankNamelist] = useState([]);
  const [BranchName, setBranchName] = useState("");
  const [BranchNamelist, setBranchNamelist] = useState([]);
  const [Accountno, setAccountno] = useState("");
  const [Panno, setPanno] = useState("");
  const [Ifsccode, setIfsccode] = useState("");
  const [Mobileno, setMobileno] = useState("");
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [GridModelList, setGridModelList] = useState([]);
  const [unqid, setUnqid] = useState("");

  useEffect(() => {
    axios
      .get("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  const inputStyle = (error) => ({
    padding: "12px 15px",
    height: "45px",
    marginTop: "5px",
    borderRadius: "6px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    fontSize: "15px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  useEffect(() => {
    fetchBankName();
    //fetchBranchName();
  }, []);

  const fetchBankName = async () => {
    try {
      const res = await apiFetch("/bank-list", {
        method: "POST",
      });

      if (!res.ok) {
        console.error("BANK FETCH ERROR:", await res.text());
        return;
      }

      const data = await res.json();

      setBankNamelist(
        (data.data || []).map((x) => ({
          value: x.data,
          label: x.value,
        })),
      );
    } catch (err) {
      console.error(err);
    }
  };

  const fetchBranchName = async (bankId) => {
    try {
      const res = await apiFetch("/branch-list", {
        method: "POST",
        body: JSON.stringify({ bankId }),
      });

      if (!res.ok) {
        console.error("BRANCH FETCH ERROR:", await res.text());
        return;
      }

      const data = await res.json();

      console.log("Branch API Response:", data.data);

      setBranchNamelist(
        (data.data || []).map((x) => ({
          value: x.value,
          label: x.data,
        })),
      );
    } catch (err) {
      console.error(err);
    }
  };
  const handleSave = async () => {
    try {
      const payload = {
        ExecutiveName,
        Panno,
        BankName,
        BranchName,
        Accountno,
        Ifsccode,
        Mobileno,
        ipAddress,
        userId: storedUserInfo?.userid || "",
        serverIp,
      };

      const res = await apiFetch(
        "/finance-executive-save",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        console.error("SAVE ERROR:", await res.text());
        alert("Save failed");
        return;
      }

      const data = await res.json();

      if (data?.data?.err === "0") {
        alert("Finance Executive saved successfully");
        navigate(-1);
      } else {
        alert(data?.data?.msg || "Save failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  const handleExit = () => {
    navigate("/FinanceexecutiveMasterGrid");
  };

  useEffect(() => {
    if (location.state?.sp_12) {
      setIsEditMode(true);
      fetchEditData(location.state.sp_12);
    }
  }, [location.state]);

  const fetchEditData = async (sp_12) => {
    try {
      const res = await apiFetch(
        "/api/finance-executive-edit",
        {
          method: "POST",
          body: JSON.stringify({ sp_12 }),
        },
      );

      if (!res.ok) {
        console.error("EDIT FETCH ERROR:", await res.text());
        return;
      }

      const result = await res.json();
      const data = result?.data?.[0];

      if (!data) return;

      setUnqid(data.unqid);
      setExecutiveName(data.name || "");
      setPanno(data.pan || "");
      setBankName(data.sp_19 || "");
      setAccountno(data.acno || "");
      setIfsccode(data.ifsc || "");
      setMobileno(data.mob || "");
      setBranchName(data.sp_20 || "");

      if (data.sp_19) {
        await fetchBranchName(data.sp_19);
        setBranchName(data.sp_20 || "");
      }
    } catch (err) {
      console.error("Edit fetch error", err);
    }
  };
  const handleUpdate = async () => {
    try {
      const payload = {
        sp_12: unqid,
        ExecutiveName,
        Panno,
        BankName,
        BranchName,
        Accountno,
        Ifsccode,
        Mobileno,
        ipAddress,
        userId: storedUserInfo?.userid || "",
        serverIp,
      };

      const res = await apiFetch(
        "/finance-executive-update",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        console.error("UPDATE ERROR:", await res.text());
        alert("Update failed");
        return;
      }

      const data = await res.json();

      if (data?.data?.err === "0") {
        alert("Finance Executive updated successfully");
        navigate("/FinanceexecutiveMasterGrid");
      } else {
        alert(data?.data?.msg || "Update failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Finance Executive Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Executive Name</label>
              <input
                type="text"
                value={ExecutiveName}
                onChange={(e) =>
                  setExecutiveName(allowAlphabets(e.target.value))
                }
                style={inputStyle(errors.Category)}
              />
            </div>

            <div className="form-column">
              <label>Bank Name</label>
              <Select
                options={BankNamelist}
                value={BankNamelist.find((o) => o.value === BankName) || null}
                onChange={(selected) => {
                  const bankId = selected ? selected.value : "";
                  setBankName(bankId);
                  setBranchName("");
                  setBranchNamelist([]);
                  if (bankId) fetchBranchName(bankId);
                }}
                placeholder="Select Bank Name"
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                    borderRadius: "6px",
                    borderColor: errors.BankName ? "red" : "#ccc",
                  }),
                }}
              />
            </div>
            <div className="form-column">
              <label>Branch Name</label>
              <Select
                options={BranchNamelist}
                value={
                  BranchNamelist.find((o) => o.value === BranchName) || null
                }
                onChange={(selected) =>
                  setBranchName(selected ? selected.value : "")
                }
                placeholder="Select Branch Name"
                isSearchable
                isDisabled={!BankName}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                    borderRadius: "6px",
                    borderColor: errors.BranchName ? "red" : "#ccc",
                  }),
                }}
              />
            </div>
            <div className="form-column">
              <label>Account Number</label>
              <input
                type="text"
                value={Accountno}
                onChange={(e) => setAccountno(allowNumbers(e.target.value))}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>Pan No</label>
              <input
                type="text"
                value={Panno}
                onChange={(e) => setPanno(e.target.value)}
                style={inputStyle(errors.Category)}
              />
            </div>
            <div className="form-column">
              <label>Ifsc Code</label>
              <input
                type="text"
                value={Ifsccode}
                onChange={(e) => setIfsccode(e.target.value)}
                style={inputStyle(errors.Ifsccode)}
              />
            </div>
            <div className="form-column">
              <label>Mobile No</label>
              <input
                type="text"
                value={Mobileno}
                onChange={(e) => setMobileno(e.target.value)}
                style={inputStyle(errors.Mobileno)}
              />
            </div>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1200px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* HEADER */
.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== FORM GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* desktop */
  gap: 16px;
  margin-bottom: 16px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 110px;
  padding: 12px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

/* ===== TABLET ===== */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ===== MOBILE ===== */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .button-container button {
    flex: 1;
  }
}

        `}
      </style>
    </Layout>
  );
};

export default FinanceexecutiveMasterDetailsDesign;
